export default "__VITE_ASSET__0fc8bbbd__"